import $ from "jquery";
import app, { u_, csl, vuwer } from "@@assets/scripts/common";

export default {
	/**
	 * URL書き換えを伴う処理はここでのみ行う
	 * ※呼び出す際はvuwer.setState関数を実行
	 * @param {Object} state
	 */
	async onChangeState(state) {
		csl.log.red("vuwer.changeState", state);
		
		const flg = { popstate: !!state.popstate };
		delete state.popstate;
		
		const childState = {};
		
		// **** view ****
		// [post]
		(u_.hasProperty(state, "post") && !state.post) && (delete state.post);
		
		const { pageQuery } = app.posts.vuw;
		const meta = { canonical: [pageQuery] };
		
		// child sections
		this.childSections.forEach(v => {
			const vuwName = `${v}Section`;
			childState[vuwName] = {};
		});
		
		// 初回は必ず一覧を更新する
		!app.isReady && (childState.listSection.update = true);
		
		
		// **** pageQuery ****
		// [list.pageQuery] 1の場合は削除
		if( u_.hasProperty(state, pageQuery) && (
			!state[pageQuery] || state[pageQuery] === "1"
		) ) {
			delete state[pageQuery];
		}
		
		if(state[pageQuery] !== this.state[pageQuery]) {
			// ページが変更になったら一覧を更新
			childState.listSection.update = true;
		}
		
		
		//// history change ////
		const hstry = (!app.isReady || flg.popstate) ? "replaceState" : "pushState";
		app[hstry](state, null, meta);
		
		
		//// render page ////
		if(app.isReady) {
			// フッターを隠して子Vuwを更新
			vuwer.get("siteFooter").$self.removeClass("fixed-bottom");
			
			const $pageMain = vuwer.get("pageMain").$self;
			$pageMain.css( "min-height", $pageMain.outerHeight() );
		}
		
		// [set children state]
		const methods = Object.keys(childState).map(vuwName => {
			return vuwer.get(vuwName).setState(childState[vuwName]);
		});
		
		// [set scroll]
		this._scrollBase = vuwer.get("pageMain").$self.offset().top;
		this._scrollBase -= vuwer.get("body").smoothScrollBuffer || 0;
		if(this.$window.scrollTop() > this._scrollBase) {
			methods.push( new Promise(resolve => {
				$(document.scrollingElement).animate({
					scrollTop: this._scrollBase
				}, "fast", resolve);
			}) );
		}
		
		
		//// async process ////
		await Promise.all(methods).catch(args => {
			u_.getAsArray(args).forEach(err => {
				if( u_.isObject(err) && isNaN(err.code) ) {
					csl.warn(err.method, err.message);
				}
				app.alert("処理中にエラーが発生しました。");
			});
		});
		
		if(app.isReady) {
			// フッターを再表示
			vuwer.get("pageMain").$self.css("min-height", "");
			vuwer.get("siteFooter").$self.addClass("fixed-bottom");
		}
	}
};
